import { render, staticRenderFns } from "./ConsentForm.vue?vue&type=template&id=4c988492"
import script from "./ConsentForm.vue?vue&type=script&lang=js"
export * from "./ConsentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c988492')) {
      api.createRecord('4c988492', component.options)
    } else {
      api.reload('4c988492', component.options)
    }
    module.hot.accept("./ConsentForm.vue?vue&type=template&id=4c988492", function () {
      api.rerender('4c988492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TemplateMaintain/ConsentForm.vue"
export default component.exports